import React, { useRef } from "react"
import { useTranslation } from "react-i18next"
import { useLocation, useHistory } from 'react-router-dom'
import { UploadMultipleView } from '../../views'
import { ModalUtil } from "../../pures"

const UploadMultipleAction = () => {
  const history = useHistory()
  const location = useLocation()
  const { t: transl } = useTranslation('upload-multiple')
  const modalUtil = new ModalUtil()

  const hashTableOptions = {
    '/create-branch-offices': {
      header: transl('newBranchOffices'),
      titleLeftComplement: transl('branchOffices'),
      fileDownload: process.env.REACT_APP_FILE_DOWNLOAD_BRANCH_OFFICE,
      endpoint: '/branch-office-csv',
      goTo: '/branch-offices-administration'
    },
    '/create-publicities': {
      header: transl('newPublicities'),
      titleLeftComplement: transl('publicities'),
      fileDownload: process.env.REACT_APP_FILE_DOWNLOAD_PUBLICITY,
      endpoint: '/publicities-csv',
      goTo: '/advertising'
    },
    '/create-offers': {
      header: transl('newOffers'),
      titleLeftComplement: transl('offers'),
      fileDownload: process.env.REACT_APP_FILE_DOWNLOAD_OFFER,
      endpoint: '/offers-csv',
      goTo: '/offers'
    }
  }

  const optionSelected = hashTableOptions[location.pathname]
  const uploadRef = useRef(null)

  const modalError = () => {
    modalUtil.showModal('error', 'Ha ocurrido un error, vuelva a intentarlo', 'Operación fallida')
  }

  const modalSuccess = async () => {
    await modalUtil.showModal('success', `Se ha cargado las ${optionSelected.titleLeftComplement} con éxito`, 'Operación exitosa')
    history.push(optionSelected.goTo)
  }

  const onStatusChange = async (event) => {
    if (event.affectedFiles[0].status === 0) modalError()

    if (event.affectedFiles[0].status === 4) modalSuccess()
  }

  return (
    <UploadMultipleView
      optionSelected={optionSelected}
      transl={transl}
      uploadRef={uploadRef}
      onStatusChange={onStatusChange}
    />
  );
}

export { UploadMultipleAction as default };